var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 490.9 490.9",
  style: {
    enableBackground: "new 0 0 490.9 490.9"
  },
  xmlSpace: "preserve"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M245.5 322.9c53 0 96.2-43.2 96.2-96.2V96.2c0-53-43.2-96.2-96.2-96.2s-96.2 43.2-96.2 96.2v130.5c0 53.1 43.2 96.2 96.2 96.2zM173.8 96.2c0-39.5 32.2-71.7 71.7-71.7s71.7 32.2 71.7 71.7v130.5c0 39.5-32.2 71.7-71.7 71.7s-71.7-32.2-71.7-71.7V96.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M94.4 214.5c-6.8 0-12.3 5.5-12.3 12.3 0 85.9 66.7 156.6 151.1 162.8v76.7h-63.9c-6.8 0-12.3 5.5-12.3 12.3s5.5 12.3 12.3 12.3h152.3c6.8 0 12.3-5.5 12.3-12.3s-5.5-12.3-12.3-12.3h-63.9v-76.7c84.4-6.3 151.1-76.9 151.1-162.8 0-6.8-5.5-12.3-12.3-12.3s-12.3 5.5-12.3 12.3c0 76.6-62.3 138.9-138.9 138.9s-138.9-62.3-138.9-138.9c.2-6.8-5.2-12.3-12-12.3z"
})));

export default SvgMic;